import { useState } from 'react';
import { createPortal } from 'react-dom';
import { FilterLines } from 'components/icons';

import './FilterLayout.scss';

const types = [
  {
    label: 'Căn hộ',
    value: 'can-ho',
  },
  {
    label: 'Tiện ích',
    value: 'tien-ich',
  },
];

const floors = ['1-5', '6-10', '11-15', '16-20', '21-25', '26-30'];

const apartmentTypes = [
  'Studio',
  '1PN',
  '1PN+',
  '1PN+1',
  '2PN',
  '2PN+',
  '3PN',
  'Duplex',
];

const utilities = [
  {
    group: 'Tiện ích T1',
    items: [
      'Cổng chào, hồ cảnh và logo dự án',
      'Bể bơi chính',
      'Bể sục Jacuzzi',
      'Bể bơi trẻ em',
      'Sân chơi trẻ em',
      'Sân thể thao đa năng',
      'Vườn nướng BBQ',
      'Khu vực thú cưng',
      'Bãi cỏ dã ngoại',
      'Sảnh đón tiếp',
      'Sảnh thang máy',
      'Sân thể thao ngoài trời',
    ],
  },
  {
    group: 'Tiện ích T13',
    items: ['Tiện ích 1', 'Tiện ích 2', 'Tiện ích 3'],
  },
];

export const FilterLayout = ({ activeFloor, setActiveFloor }) => {
  const [activeType, setActiveType] = useState('can-ho');
  const [activeApartment, setActiveApartment] = useState(null);
  const [activeUtility, setActiveUtility] = useState(null);
  const [expandedGroups, setExpandedGroups] = useState(['Tiện ích T1']);
  const [isFloorDropdownOpen, setFloorDropdownOpen] = useState(false);
  const [isApartmentDropdownOpen, setApartmentDropdownOpen] = useState(false);

  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  const isMobile = window.innerWidth <= 430;

  const toggleGroup = (group) => {
    setExpandedGroups((prev) =>
      prev.includes(group) ? prev.filter((g) => g !== group) : [...prev, group]
    );
  };

  const handleFloorSelect = (floor) => {
    setActiveFloor(activeFloor === floor ? null : floor);
    setFloorDropdownOpen(false);
  };

  const handleApartmentSelect = (type) => {
    setActiveApartment(activeApartment === type ? null : type);
    setApartmentDropdownOpen(false);
  };

  const handleUtilitySelect = (utility) => {
    setActiveUtility(activeUtility === utility ? null : utility);
  };

  const handleReset = () => {
    setActiveFloor(null);
    setActiveApartment(null);
    setActiveUtility(null);
  };

  if (isMobile) {
    return createPortal(
      <div>
        <div className="filter-type-selector mobile">
          {types.map((type) => (
            <div
              key={type.value}
              className={`filter-item ${
                activeType === type.value ? 'active' : ''
              }`}
              onClick={() => setActiveType(type.value)}
            >
              {type.label}
            </div>
          ))}
        </div>
        <div className="filter-layout-mobile">
          <div className="filter-select-trigger-wrapper">
            <button
              className={`filter-select-trigger ${
                mobileFilterOpen ? 'active' : ''
              }`}
              onClick={() => setMobileFilterOpen(!mobileFilterOpen)}
            >
              <FilterLines size={20} color="#000" />
              <span>Filters</span>
            </button>
          </div>
          {mobileFilterOpen &&
            (activeType === 'can-ho' ? (
              <div className="can-ho-filters-mobile">
                <div className="filter-section-mobile">
                  <h3 className="filter-title">Tầng điển hình</h3>
                  <div className="custom-dropdown">
                    <div
                      className="dropdown-selected"
                      onClick={() => setFloorDropdownOpen(!isFloorDropdownOpen)}
                    >
                      <div className="dropdown-selected-label">
                        {activeFloor || 'Chọn tầng'}
                        <span
                          className={`arrow ${
                            isFloorDropdownOpen ? 'up' : 'down'
                          }`}
                        />
                      </div>
                    </div>
                    {isFloorDropdownOpen && (
                      <div className="dropdown-options">
                        {floors.map((floor) => (
                          <div
                            key={floor}
                            className="dropdown-option"
                            onClick={() => handleFloorSelect(floor)}
                          >
                            {floor}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="filter-section-mobile">
                  <h3 className="filter-title">Loại căn hộ</h3>
                  <div className="custom-dropdown">
                    <div
                      className="dropdown-selected"
                      onClick={() =>
                        setApartmentDropdownOpen(!isApartmentDropdownOpen)
                      }
                    >
                      <div className="dropdown-selected-label">
                        {activeApartment || 'Chọn loại căn hộ'}
                        <span
                          className={`arrow ${
                            isApartmentDropdownOpen ? 'up' : 'down'
                          }`}
                        />
                      </div>
                    </div>
                    {isApartmentDropdownOpen && (
                      <div className="dropdown-options">
                        {apartmentTypes.map((type) => (
                          <div
                            key={type}
                            className="dropdown-option"
                            onClick={() => handleApartmentSelect(type)}
                          >
                            {type}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="filter-section-mobile">
                  <h3 className="filter-title">Diện tích thông thuỷ</h3>
                  <div className="range-slider-mobile">
                    <input type="range" min="0" max="100" defaultValue="20" />
                    <span>Nhỏ hơn 40m2</span>
                  </div>
                </div>

                <button className="reset-button-mobile" onClick={handleReset}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_1551_23742)">
                      <path
                        d="M14.3962 8.97047C13.9279 12.0836 11.2417 14.4705 7.99793 14.4705C4.42432 14.4705 1.52734 11.5735 1.52734 7.99988C1.52734 4.42628 4.42432 1.5293 7.99793 1.5293C10.6513 1.5293 12.9316 3.12636 13.9301 5.41165M14.4685 2.17636V5.02341C14.4685 5.23783 14.2947 5.41165 14.0803 5.41165H11.2332"
                        stroke="#171717"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1551_23742">
                        <rect
                          width="15.5294"
                          height="15.5294"
                          fill="white"
                          transform="translate(0.234375 0.235352)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
            ) : (
              <div className="tien-ich-filters">
                {utilities.map((utilityGroup) => {
                  const isExpanded = expandedGroups.includes(
                    utilityGroup.group
                  );
                  return (
                    <div key={utilityGroup.group} className="utility-group">
                      <div
                        className="utility-group-header"
                        onClick={() => toggleGroup(utilityGroup.group)}
                      >
                        <h3>{utilityGroup.group}</h3>
                        <span
                          className={`arrow ${isExpanded ? 'up' : 'down'}`}
                        />
                      </div>
                      {isExpanded && (
                        <div className="utility-items">
                          {utilityGroup.items.map((item) => (
                            <div
                              key={item}
                              className={`utility-item ${
                                activeUtility === item ? 'active' : ''
                              }`}
                              onClick={() => handleUtilitySelect(item)}
                            >
                              {item}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
                <button className="reset-button-mobile" onClick={handleReset}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_1551_23742)">
                      <path
                        d="M14.3962 8.97047C13.9279 12.0836 11.2417 14.4705 7.99793 14.4705C4.42432 14.4705 1.52734 11.5735 1.52734 7.99988C1.52734 4.42628 4.42432 1.5293 7.99793 1.5293C10.6513 1.5293 12.9316 3.12636 13.9301 5.41165M14.4685 2.17636V5.02341C14.4685 5.23783 14.2947 5.41165 14.0803 5.41165H11.2332"
                        stroke="#171717"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1551_23742">
                        <rect
                          width="15.5294"
                          height="15.5294"
                          fill="white"
                          transform="translate(0.234375 0.235352)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
            ))}
        </div>
      </div>,
      document.body
    );
  }

  return (
    <div className="filter-layout">
      <div className="filter-type-selector">
        {types.map((type) => (
          <div
            key={type.value}
            className={`filter-item ${
              activeType === type.value ? 'active' : ''
            }`}
            onClick={() => setActiveType(type.value)}
          >
            {type.label}
          </div>
        ))}
      </div>

      {activeType === 'can-ho' && (
        <div className="can-ho-filters">
          <div className="filter-section">
            <h3 className="filter-title">Tầng điển hình</h3>
            <div className="filter-grid">
              {floors.map((floor) => (
                <div
                  key={floor}
                  className={`filter-grid-item ${
                    activeFloor === floor ? 'active' : ''
                  }`}
                  onClick={() => setActiveFloor(floor)}
                >
                  {floor}
                </div>
              ))}
            </div>
          </div>

          <div className="filter-section">
            <h3 className="filter-title">Loại căn hộ</h3>
            <div className="filter-grid">
              {apartmentTypes.map((type) => (
                <div
                  key={type}
                  className={`filter-grid-item ${
                    activeApartment === type ? 'active' : ''
                  }`}
                  onClick={() => setActiveApartment(type)}
                >
                  {type}
                </div>
              ))}
            </div>
          </div>

          <div className="filter-section">
            <h3 className="filter-title">Diện tích thông thuỷ</h3>
            <div className="range-slider">
              <input type="range" min="0" max="100" defaultValue="20" />
              <span>Nhỏ hơn 40m2</span>
            </div>
          </div>

          <button className="reset-button" onClick={handleReset}>
            Đặt lại
          </button>
        </div>
      )}

      {activeType === 'tien-ich' && (
        <div className="tien-ich-filters">
          {utilities.map((utilityGroup) => {
            const isExpanded = expandedGroups.includes(utilityGroup.group);
            return (
              <div key={utilityGroup.group} className="utility-group">
                <div
                  className="utility-group-header"
                  onClick={() => toggleGroup(utilityGroup.group)}
                >
                  <h3>{utilityGroup.group}</h3>
                  <span className={`arrow ${isExpanded ? 'up' : 'down'}`} />
                </div>
                {isExpanded && (
                  <div className="utility-items">
                    {utilityGroup.items.map((item) => (
                      <div
                        key={item}
                        className={`utility-item ${
                          activeUtility === item ? 'active' : ''
                        }`}
                        onClick={() => handleUtilitySelect(item)}
                      >
                        {item}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
          <button className="reset-button" onClick={handleReset}>
            Đặt lại
          </button>
        </div>
      )}
    </div>
  );
};
